import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import swal from 'sweetalert';

import axios from '../../../services/MyAxios';

function FreespinCampaignEdit() {
    const [campaign, setCampaign] = useState({
        image: null,
    });
    const [previewImage, setPreviewImage] = useState('');
    const [errors, setErrors] = useState([]);
    const history = useHistory();
    const { id } = useParams();

    useEffect(() => {
        const url = `/crea/casino/api/freespin-campaigns/${id}`;
        axios
            .get(url)
            .then((response) => {
                setCampaign(response.data);
            })
            .catch((error) => {
                if (error.response.status && error.response.status === 404) {
                    history.push({
                        pathname: '/freespin-campaigns',
                    });
                }
            });
    }, []);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        setCampaign({
            ...campaign,
            image: file,
        });
        setPreviewImage(URL.createObjectURL(file));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // eslint-disable-next-line no-console
        console.log('Bonus image:', campaign.image);
        const formData = new FormData();
        formData.append('image', campaign.image);
        // eslint-disable-next-line no-restricted-syntax
        for (const pair of formData.entries()) {
            // eslint-disable-next-line no-console
            console.log(`${pair[0]}, ${pair[1]}`);
        }
        axios
            .post(`/crea/casino/api/freespin-campaigns/${id}/edit`, formData, {
                headers: {
                    Accept: 'application/json',
                    // 'content-type': 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.data) {
                    swal({
                        title: 'Success',
                        text: 'Freespin campaign updated correctly',
                        icon: 'success',
                    }).then(() => {
                        history.push('/freespin-campaigns');
                    });
                }
            })
            .catch((error) => {
                if (!error.response) {
                    setErrors(error.message);
                } else if (error.response.status !== 500) {
                    setErrors(error.response.data.errors);
                } else {
                    swal({
                        title: 'Error',
                        text: 'Server error',
                        icon: 'error',
                    });
                }
            });
    };

    function hasErrorFor(field) {
        return !!errors[field];
    }

    function renderErrorFor(field) {
        if (hasErrorFor(field)) {
            return (
                <span className="invalid-feedback" style={{ display: 'block' }}>
                    <strong>{errors[field][0]}</strong>
                </span>
            );
        }
        return '';
    }

    return (
        <div className="card">
            <div className="card-body">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="form-group">
                        {(previewImage || campaign.image_url) && (
                            <img
                                src={previewImage || campaign.image_url}
                                style={{ maxWidth: '100px', height: 'auto' }}
                                alt="current icon"
                            />
                        )}

                        <label htmlFor="image">
                            Image in .png format: <br />
                            <input
                                className="form-control"
                                type="file"
                                accept=".png"
                                name="image"
                                onChange={handleImageChange}
                            />
                        </label>
                        {renderErrorFor('image')}
                    </div>
                    <button type="submit" className="btn btn-primary">
                        Update
                    </button>
                </form>
            </div>
        </div>
    );
}

export default FreespinCampaignEdit;
